export default __webpack_public_path__ + "static/media/image-sx.c30a2f87.png";